import {
  Sparkles, Wand2, Flower2, Eye, Palette, Leaf,
  Feather, Droplets, Sun, Zap, Hand, FlaskConical, CircleDot, HeartPulse, ShieldCheck,
} from "lucide-react";

/**
 * SERVICE_ICONS - shared icon registry for data-driven service rendering.
 * Service entries in business.js reference icons by name; pages resolve them here.
 */
export const SERVICE_ICONS = {
  Sparkles, Wand2, Flower2, Eye, Palette, Leaf,
  Feather, Droplets, Sun, Zap, Hand, FlaskConical, CircleDot, HeartPulse, ShieldCheck,
};

/** Resolve an icon component by name with a safe fallback. */
export const getServiceIcon = (name) => SERVICE_ICONS[name] || Sparkles;
